/**
 * loggr.ts - Loggr (Logging & Debugging) preferences module
 * 
 * CHANGE HISTORY:
 * - 251031_1540 [pending] danielbeer: Added package metadata
 * - 251023_1854 [pending] danielbeer: Initial creation
 */

export const loggrModule = {
  id: 'system-loggr',
  name: 'Logging & Debugging',
  icon: '📝',
  category: 'advanced',
  order: 1,
  
  // Package metadata for info panel
  packageInfo: {
    name: '@opcentral/loggr',
    version: '0.2.0+251021002750',
    displayVersion: '0.2.0',
    description: 'Universal session and activity tracking for OpCentral',
    status: 'implemented',
    implementationProgress: 85,
    dependencies: {
      '@opcentral/core': '*',
      '@opcentral/actr': '*'
    },
    keywords: ['logging', 'session', 'activity', 'tracking', 'timeline', 'audit'],
    author: 'OpCentral',
    license: 'MIT'
  },
  
  settings: {
    logLevel: {
      type: 'select',
      label: 'Log Level',
      description: 'Minimum severity level for logs',
      defaultValue: 'info',
      options: [
        { label: 'Error', value: 'error' },
        { label: 'Warning', value: 'warn' },
        { label: 'Info', value: 'info' },
        { label: 'Debug', value: 'debug' },
        { label: 'Trace', value: 'trace' }
      ]
    },
    
    enableConsoleLogging: {
      type: 'boolean',
      label: 'Console Logging',
      description: 'Output logs to browser console',
      defaultValue: true
    },
    
    enableFileLogging: {
      type: 'boolean',
      label: 'File Logging',
      description: 'Save logs to file',
      defaultValue: false
    },
    
    logRetentionDays: {
      type: 'number',
      label: 'Log Retention (days)',
      description: 'How long to keep log files',
      defaultValue: 7,
      min: 1,
      max: 90,
      visible: (settings) => settings['system-loggr.enableFileLogging']
    },
    
    includeTimestamps: {
      type: 'boolean',
      label: 'Include Timestamps',
      description: 'Add timestamps to log entries',
      defaultValue: true
    },
    
    includeStackTraces: {
      type: 'boolean',
      label: 'Include Stack Traces',
      description: 'Add stack traces to error logs',
      defaultValue: true
    },
    
    debugMode: {
      type: 'boolean',
      label: 'Debug Mode',
      description: 'Enable verbose debugging output',
      defaultValue: false
    }
  }
};

export default loggrModule;
